import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { clearCanvas, drawRotatedImages, getImage, toImage } from "../util.js"

rendererResolvers.push(
	({ item }) => {
		if (item != Item.EXPANDO_BOX)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const canvas = createCanvas(0, 0)
				const ctx = canvas.getContext("2d")

				const imgBase = await getImage(item.buildInfo[0].image)
				const imgMid = await getImage("exbox_mid")
				const imgCorner = await getImage("exbox_corner")
				const imgCenter = await getImage("exbox_center")
				const imgBorder = await getImage("exbox_border")

				clearCanvas(canvas, ctx, imgBase.width, imgBase.height) // not drawing base 

				const midX = imgBase.width / 2, midY = imgBase.height / 2

				drawRotatedImages(ctx, imgBorder, [
					[0, midX, midY - 10], // R
					[90, midX + 10, midY], // B
					[180, midX, midY + 10], // L
					[-90, midX - 10, midY], // T
				], 0, imgBorder.height / 2, imgBorder.width, imgBase.height - 20) // origin = left center of image

				ctx.drawImage(imgMid, 5, 5, imgBase.width - 10, imgBase.height - 10)

				drawRotatedImages(ctx, imgCorner, [
					[0, midX, midY], // TL
					[90, midX, midY], // TR
					[180, midX, midY], // BR
					[-90, midX, midY], // BL
				], imgCorner.width, imgCorner.height) // origin = right bottom of image

				ctx.drawImage(imgCenter, midX - imgCenter.width / 2, midY - imgCenter.height / 2)

				return [{ image: await toImage(canvas) }]
			}
		}
	}
)
